import apiClient from "@/services/apiClient";

export const adminAttendanceService = {
  getAttendance: async (filters) => {
    const response = await apiClient.get("/AdminAttendance", { params: filters });
    return response.data;
  },
  getAttendanceByStudentBooking: async (studentBookingId) => {
    const response = await apiClient.get("/AdminAttendance/StudentBooking", {
      params: { pStudentBookingId: studentBookingId },
    });
    return response.data;
  },
  saveAttendance: async (payload) => {
    const response = await apiClient.post("/AdminAttendance/Save", payload);
    return response.data;
  },
};
